import React from "react"
import { SettingsProvider } from "./src/contexts/settings"

const wrapRootElement = ({ element }) => (
    <SettingsProvider>{element}</SettingsProvider>
)
export { wrapRootElement }